import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from 'src/app/app.module';
import * as utils from '../../helpers/utils';
import { User } from 'src/app/core/models/user.model';

const user: User = utils?.localStorageGetItem('user');

const routes: Routes = []

if (user.roleId === 1) {
    routes.push({
        path: '',
        loadChildren: () => import('src/app/shared/admin/admin-bg-processes/admin-bg-processes.module').then(m => m.AdminBgProcessesModule),
        outlet: 'bg-processes'
    })
}

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en-GB'
        }),
        CommonModule
    ],

    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class BgProcessesContainerRoutingModule { }